















import { DateTime } from 'luxon';
import {Vue, Component, Prop } from 'vue-property-decorator';

import TableArrows from "@share/common/table-arrows/TableArrows.vue";

@Component({
    name: 'MeetingsTableHead',
    components: { TableArrows }
})
export default class MeetingsTableHead extends Vue {
    @Prop({ required: true }) timeFrames: DateTime[];

    sortDirection = "asc";
    fieldName = ""

    sort() {
        this.toggleSortDirection();

        this.fieldName = "name";

        this.$emit('sort', this.sortDirection)
    }

    toggleSortDirection() {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    }
}

